import _ from 'lodash'
import { MutationTree } from 'vuex'
import { PreparationState, Preparation } from '@/store/lessons/preparation/types'

const mutations: MutationTree<PreparationState> = {
  gotPreparation: (state, preparation: Preparation) => {
    state.preparation = preparation;
  },

}

export default mutations
